import React from 'react'
import poweredByIcon from "../../images/powered-by.svg"

const Footer = () => {
  return (
    <div className="footer-main">
      <img src={poweredByIcon} alt="poweredByIcon" />
    </div>
  )
}

export default Footer